export default "__VITE_ASSET__DaHb4ERi__"